const PRODUCT_CLICKED = 'product-clicked';
const GROUP_CLICKED = 'group-clicked';

export default {
	PRODUCT_CLICKED,
	GROUP_CLICKED,
};
